import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=2a98f16e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a98f16e')) {
      api.createRecord('2a98f16e', component.options)
    } else {
      api.reload('2a98f16e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=2a98f16e&", function () {
      api.rerender('2a98f16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j3aZpr5hgMl3/JS/videoIframe.vue"
export default component.exports